'use strict';
import forEach from 'lodash/forEach';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';
import isUndefined from 'lodash/isUndefined';
import {blockPromise} from '../misc-utils/MiscUtils';

InPlaceEditorFactory.$inject = [];

export function InPlaceEditorFactory() {
  return InPlaceEditor;
}

export class InPlaceEditor {
  constructor(options) {
    InPlaceEditor._validateOptions(options);
    Object.defineProperties(this, {
      __config: {
        value: options
      },
      __firstEditor: {
        writable: true,
        value: null
      },
      __editors: {
        writable: true,
        value: {}
      },
      __working: {
        writable: true,
        value: false
      }
    });

    this.blockingSave = blockPromise(this.save.bind(this));
  }


  addEditor(editor, property) {
    this.__firstEditor = null;
    this.__editors[property] = editor;
  }

  removeEditor(editor, property) {
    if (editor === this.__editors[property]) {
      this.__firstEditor = null;
      this.__editors[property] = null;
    }
  }

  getEditor(property) {
    return this.__editors[property];
  }

  save() {
    this.__working = true;
    const promise = this.__config.update
      ? this.__config.update()
      : this.__config.getModel().$save();

    return promise.then(() => {
      this.__working = false;
      this.__exitEditMode(false);
    }, (errors) => {
      this.__working = false;
      console.error(errors); // todo, show in view
      return Promise.reject(errors);
    });
  }

  revert() {
    if (this.__config.revert) {
      this.__config.revert();
    }
    this.__exitEditMode(true);
  }

  isEditMode() {
    if (this.__getFirst()) {
      return this.__firstEditor.isEditMode()
    }
  }

  isWorking() {
    return this.__working;
  }

  edit() {
    forEach(this.__editors, editor => {
      editor.edit();
    });
  }

  view() {
    this.__exitEditMode(false);
  }

  toggle() {
    if (this.__getFirst()) {
      if (this.__firstEditor.isEditMode()) {
        this.revert();
      } else {
        this.edit();
      }
    }
  }

  __getFirst() {
    if (!this.__firstEditor) this.__firstEditor = this.__editors[Object.keys(this.__editors)[0]];
    return this.__firstEditor;
  }

  __exitEditMode(revert) {
    forEach(this.__editors, editor => {
      if (isObject(editor) && editor.revert) {
        revert && editor.revert();
        editor.view();
      }
    });
  }

  static _validateOptions(options) {
    if (!isObject(options)) {
      throw new Error('InPlaceEditor: Invalid configuration options provided. Must be an object ', options);
    }

    if (!isFunction(options.getModel)) {
      throw new Error('InPlaceEditor: Invalid configuration options provided. Requires a valid getModel function ', options.getModel);
    }

    if (!isUndefined(options.update) && !isFunction(options.update)) {
      throw new Error('InPlaceEditor: Invalid configuration options provided. If provided, \'update\' must be a function ', options.update);
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/domain/InPlaceEditorService.js